/**
 * Űrlap section — Collapsible csoportok toggle (pl. "Cégként érdeklődöm")
 *
 * Egy form-on belül egy [data-toggle-target="X"] checkbox kapcsolja a
 * megfelelő [data-collapsible="X"] csoport láthatóságát.
 *
 * - Form-scope: a kereső a `closest('form')`-ot használja, így több
 *   form egy oldalon is biztonságosan elszigetelt.
 * - hidden attribútum kezelése: bekapcsolva eltávolítjuk, kikapcsolva
 *   visszatesszük; reset esetén is megfelelően áll vissza.
 */
(function () {
  var toggles = document.querySelectorAll('[data-toggle-target]');
  if (!toggles.length) return;

  function findGroups(form, target) {
    if (!form) return [];
    return form.querySelectorAll('[data-collapsible="' + target + '"]');
  }

  function applyState(form, target, checked) {
    var groups = findGroups(form, target);
    for (var j = 0; j < groups.length; j++) {
      if (checked) {
        groups[j].removeAttribute('hidden');
      } else {
        groups[j].setAttribute('hidden', '');
      }
    }
  }

  for (var i = 0; i < toggles.length; i++) {
    (function (input) {
      var target = input.getAttribute('data-toggle-target');
      var form   = input.closest('form');

      applyState(form, target, input.checked);

      input.addEventListener('change', function () {
        applyState(form, target, input.checked);
      });

      /* Form reset után állítsuk vissza a státuszt (a reset egy tick múlva érvényesül) */
      if (form) {
        form.addEventListener('reset', function () {
          setTimeout(function () {
            applyState(form, target, input.checked);
          }, 0);
        });
      }
    })(toggles[i]);
  }
})();
